import React from "react";
import { Link } from "react-router-dom";
import "./CTA.css";

const CTA = ({ title, description, buttonText, buttonLink }) => {
    return (
        <section className="cta-container">
            <h2 className="cta-title">{title}</h2>
            <p
                className='cta-description'
                dangerouslySetInnerHTML={{ __html: description }}
            />
            <Link to={buttonLink} className="cta-button">
                {buttonText}
            </Link>
        </section>
    );
};

export default CTA;
